import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import { filmAPI } from '../../services/api';
import './FilmUpload.css';

const FilmUpload = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    youtube_link: '',
    cover_image: null,
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) { // 2MB limit
        setMessage({ type: 'error', text: 'File size must be less than 2MB' });
        return;
      }
      
      setFormData({
        ...formData,
        cover_image: file,
      });
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await filmAPI.createFilm(formData);
      setMessage({ 
        type: 'success', 
        text: 'Film uploaded successfully! Redirecting...' 
      });
      
      setTimeout(() => {
        navigate('/films');
      }, 2000);
    } catch (error) {
      console.error('Upload error:', error);
      setMessage({ 
        type: 'error', 
        text: error.response?.data?.error || 'Failed to upload film' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="film-upload-container">
        <div className="upload-header">
          <h1>Upload New Film</h1>
          <p>Add a new film to the website</p>
        </div>
        
        <form onSubmit={handleSubmit} className="upload-form">
          <div className="form-row">
            <div className="form-column">
              <div className="form-group">
                <label>Film Title *</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter film title"
                />
              </div>
              
              <div className="form-group">
                <label>YouTube Link *</label>
                <input
                  type="url"
                  name="youtube_link"
                  value={formData.youtube_link}
                  onChange={handleInputChange}
                  required
                  placeholder="https://www.youtube.com/watch?v=..."
                />
                <small className="form-hint">
                  Full YouTube URL including https://
                </small>
              </div>
              
              <div className="form-group">
                <label>Description *</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                  rows="6"
                  placeholder="Describe the film..."
                  maxLength="500"
                />
                <small className="form-hint">
                  {formData.description.length}/500 characters
                </small>
              </div>
            </div>
            
            <div className="form-column">
              <div className="form-group">
                <label>Cover Image *</label>
                <div className="file-upload-area">
                  <input
                    id="cover_image"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    required
                    className="file-input"
                  />
                  <label htmlFor="cover_image" className="file-label">
                    {preview ? 'Change Image' : 'Choose Image'}
                  </label>
                  <small className="form-hint">
                    Max size: 2MB • Formats: JPG, PNG, GIF
                  </small>
                </div>
                
                {preview && (
                  <div className="image-preview">
                    <img src={preview} alt="Preview" />
                    <div className="preview-overlay">
                      <span>Preview</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
          {message.text && (
            <div className={`alert alert-${message.type}`}>
              {message.text}
            </div>
          )}
          
          <div className="form-actions">
            <button 
              type="button" 
              className="btn-secondary"
              onClick={() => navigate('/admin/films')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-primaryy"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Uploading...
                </>
              ) : 'Upload Film'}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  );
};

export default FilmUpload;